module.exports = __webpack_public_path__ + "img/pt.c083066e.svg";